import { LessonGroupExamDetailPage } from "@/pages/groups/toets-overzicht/LessonGroupExamDetailPage"
import { checkPermissions } from "@/utils/checkPermissions"
import { parseLessonGroupExamEntryId } from "@/utils/lessonGroupExamEntryId"
import { createFileRoute, redirect, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/toets-overzicht/$entryId",
)({
  component: RouteComponent,
  beforeLoad: ({ params }) => {
    checkPermissions("read", "groups")

    try {
      parseLessonGroupExamEntryId(decodeURIComponent(params.entryId))
    } catch {
      throw redirect({
        to: "/beheer/groepen/$groupId/toets-overzicht",
        params: { groupId: params.groupId },
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  const { groupId, entryId } = useParams({
    from: "/beheer/groepen/$groupId/toets-overzicht/$entryId",
  })

  return (
    <LessonGroupExamDetailPage
      groupId={Number(groupId)}
      entryId={decodeURIComponent(entryId)}
    />
  )
}
